import { FiltersTypes } from 'store/modules/online_search_store/types';
import Api from '../api';

interface CreateCustomSearchProps {
  contact_id: number;
  name: string;
  filters: Partial<FiltersTypes>;
  service_id?: number;
  ai?: boolean;
}

export interface CustomSearches {
  id: number;
  name: string;
  filters: FiltersTypes;
  ai: boolean;
}

export const createCustomSearch = async (data: CreateCustomSearchProps) => {
  const response = await Api.post('/custom_searches', data);
  return response?.data;
};

export const getCustomSearch = async (contact_client_id: number, service_id?: number) => {
  const params: any = { contact_client_id };
  if (service_id) params.service_id = service_id;
  const response = await Api.get('/custom_searches', { params });
  return response?.data;
};

export const updateCustomSearch = async (id: number, data: CreateCustomSearchProps) => {
  const response = await Api.put(`/custom_searches/${id}`, data);
  return response?.data;
};

export const deleteCustomSearch = async (searchId: number) => {
  const response = await Api.delete(`/custom_searches/${searchId}`);
  return response?.data;
};
